export type StaticConfigEnvironment = "dev" | "stg" | "prod"

const STATIC_CONFIG_ENVIRONMENTS: StaticConfigEnvironment[] = [
  "dev",
  "stg",
  "prod",
]

export const STATIC_CONFIG_BASE_URL =
  import.meta.env.VITE_STATIC_CONFIG_BASE_URL ?? ""

export const STATIC_CONFIG_PATH =
  import.meta.env.VITE_STATIC_CONFIG_PATH ?? "gas_sponsor/config.json"

export const STATIC_CONFIG_ENV: StaticConfigEnvironment =
  STATIC_CONFIG_ENVIRONMENTS.includes(
    import.meta.env.VITE_STATIC_CONFIG_ENV as StaticConfigEnvironment
  )
    ? (import.meta.env.VITE_STATIC_CONFIG_ENV as StaticConfigEnvironment)
    : "dev"

export const STATIC_CONFIG_URL = `${STATIC_CONFIG_BASE_URL.replace(
  /\/$/,
  ""
)}/${STATIC_CONFIG_ENV}/${STATIC_CONFIG_PATH.replace(/^\//, "")}`
